// extracted by mini-css-extract-plugin
export default {"NovelsFilters":"NovelsFilters_NovelsFilters__J8jo1"};